module.exports = __webpack_public_path__ + "img/tarteSugar1.19aa76d4.jpg";